/*
 * Display-only currency estimates for the SoflePLUS2 builder. The store charges in MYR (and Shopify already adds
 * the international market's +7% to foreign visitors' prices), so these figures only help a foreign client read
 * the price. Daily reference rates come from free public sources that browsers may read directly (no key):
 *   1. Frankfurter (European Central Bank rates, ~30 currencies)   https://frankfurter.dev
 *   2. ExchangeRate-API open endpoint (160+ currencies, fallback)    https://www.exchangerate-api.com
 * Rates are cached in the browser for 12 hours. Browser global: window.SP2Currency.
 */
(function (root) {
  'use strict';

  var BASE = 'MYR';
  var CACHE_KEY = 'sp2_rates_' + BASE;
  var MAX_AGE = 12 * 3600 * 1000;
  var EURO = 'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK'.split(' ');
  var BY_COUNTRY = {
    US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', NZ: 'NZD', SG: 'SGD', JP: 'JPY', KR: 'KRW', CN: 'CNY',
    HK: 'HKD', TW: 'TWD', TH: 'THB', ID: 'IDR', PH: 'PHP', VN: 'VND', IN: 'INR', AE: 'AED', SA: 'SAR',
    CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN', CZ: 'CZK', HU: 'HUF', BR: 'BRL', MX: 'MXN',
    ZA: 'ZAR', IL: 'ILS', TR: 'TRY', BN: 'BND', MY: 'MYR'
  };
  // offered in the currency picker, most common first
  var COMMON = ['USD', 'SGD', 'EUR', 'GBP', 'AUD', 'JPY', 'CAD', 'HKD', 'TWD', 'KRW', 'CNY', 'THB', 'IDR', 'PHP', 'INR', 'NZD', 'CHF'];

  function currencyForCountry(cc) {
    cc = String(cc || '').toUpperCase();
    if (EURO.indexOf(cc) >= 0) return 'EUR';
    return BY_COUNTRY[cc] || 'USD';
  }

  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.fetched < MAX_AGE) return c;
    } catch (e) { /* storage blocked or corrupt: fetch again */ }
    return null;
  }

  function writeCache(c) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(c)); } catch (e) { /* fine without a cache */ }
  }

  function getJSON(url) {
    return fetch(url).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  // -> { rates: { USD: 0.2448, ... }, date: '2026-10-02', source: 'ECB via Frankfurter' }
  function loadRates() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);
    var ecb = getJSON('https://api.frankfurter.dev/v1/latest?base=' + BASE).then(function (d) {
      return { rates: d.rates, date: d.date, source: 'European Central Bank (via Frankfurter)' };
    });
    var wide = getJSON('https://open.er-api.com/v6/latest/' + BASE).then(function (d) {
      if (d.result !== 'success') throw new Error('rates unavailable');
      return { rates: d.rates, date: (d.time_last_update_utc || '').slice(5, 16), source: 'ExchangeRate-API' };
    });
    // ECB rates where they exist; the wider list fills the currencies the ECB doesn't publish (TWD, VND, AED...)
    return Promise.allSettled([ecb, wide]).then(function (r) {
      var a = r[0].status === 'fulfilled' ? r[0].value : null;
      var b = r[1].status === 'fulfilled' ? r[1].value : null;
      if (!a && !b) throw new Error('No exchange rates available right now.');
      var out = { rates: Object.assign({}, b && b.rates, a && a.rates), date: (a || b).date,
        source: a ? a.source + (b ? ' + ExchangeRate-API' : '') : b.source, fetched: Date.now() };
      out.rates[BASE] = 1;
      writeCache(out);
      return out;
    });
  }

  function format(amount, code) {
    try {
      // the ISO code, not "$": US, Singapore, Australian... dollars must be told apart
      return new Intl.NumberFormat('en', { style: 'currency', currency: code, currencyDisplay: 'code' }).format(amount);
    } catch (e) {
      return code + ' ' + amount.toFixed(2);
    }
  }

  // cents in MYR -> "≈ US$190.12", or null when there's no rate for that currency
  function estimate(cents, code, rates) {
    var r = rates && rates.rates[code];
    if (!r || code === BASE) return null;
    return '≈ ' + format(cents / 100 * r, code);
  }

  root.SP2Currency = { BASE: BASE, COMMON: COMMON, currencyForCountry: currencyForCountry, loadRates: loadRates, format: format, estimate: estimate };
})(typeof self !== 'undefined' ? self : this);
